export default "__VITE_ASSET__BmYaVHlD__"